export default {

    init() {

        const DATA_PAYMENT_ID = "payment-id";

        const TABLE_CONSULENZE = "#table-consulenze";
        const TABLE_CONSULENZE_BODY = "#table-consulenze tbody";

        const TABLE_VENDITE = "#table-vendite";
        const TABLE_VENDITE_BODY = "#table-vendite tbody";

        const TABLE_CANALI_DI_VENDITA = "#table-canali-di-vendita";
        const TABLE_CANALI_DI_VENDITA_BODY = "#table-canali-di-vendita tbody";

        const TABLE_FATTURE_CATALOGO = "#table-fatture-catalogo";
        const TABLE_FATTURE_CATALOGO_BODY = "#table-fatture-catalogo tbody";

        const TABLE_FATTURE_FUORI_CATALOGO = "#table-fatture-fuori-catalogo";
        const TABLE_FATTURE_FUORI_CATALOGO_BODY = "#table-fatture-fuori-catalogo tbody";

        const BTN_MARK_AS_PAID = ".btn-mark-as-paid";

        const CONSULENZE = "consulenze";
        const VENDITE = "vendite";
        const CANALI_DI_VENDITA = "canali_di_vendita";
        const FATTURE_CATALOGO = "fatture_catalogo";
        const FATTURE_FUORI_CATALOGO = "fatture_fuori_catalogo";

        const INPUT_SITE_ID = "#input-site-id";
        const INPUT_FILTER_PAID = "#input-filter-paid";
        const INPUT_FILTER_DATE_FROM = "#input-filter-date-from";
        const INPUT_FILTER_DATE_TO = "#input-filter-date-to";

        const TH_CONSULENZE_AMOUNT = "#th-consulenze-amount";
        const TH_VENDITE_AMOUNT = "#th-vendite-amount";
        const TH_CANALI_DI_VENDITA_AMOUNT = "#th-canali-di-vendita-amount";
        const TH_FATTURE_CATALOGO_AMOUNT = "#th-fatture-catalogo-amount";
        const TH_FATTURE_FUORI_CATALOGO_AMOUNT = "#th-fatture-fuori-catalogo-amount";

        function getFilterFormData() {

            return {
                site_id: $(INPUT_SITE_ID).val(),
                paid: $(INPUT_FILTER_PAID).val(),
                date_from: $(INPUT_FILTER_DATE_FROM).val(),
                date_to: $(INPUT_FILTER_DATE_TO).val(),
            }
        }

        function accountingLoaded(accounting) {

            $(TH_CONSULENZE_AMOUNT).text(numeral(accounting['importo_consulenze_totale']).format('0,0.00'));
            $(TH_VENDITE_AMOUNT).text(numeral(accounting['importo_vendite_totale']).format('0,0.00'));
            $(TH_CANALI_DI_VENDITA_AMOUNT).text(numeral(accounting['importo_canali_di_vendita_totale']).format('0,0.00'));
            $(TH_FATTURE_CATALOGO_AMOUNT).text(numeral(accounting['importo_fatture_catalogo_totale']).format('0,0.00'));
            $(TH_FATTURE_FUORI_CATALOGO_AMOUNT).text(numeral(accounting['importo_fatture_fuori_catalogo_totale']).format('0,0.00'));
        }

        function loadAccounting() {

            const params = getFilterFormData();
            params['wants_html'] = 0;

            httpRequest.get(`admin/content/api/accounting/credits/accounting`, {
                params: params
            }).then(response => accountingLoaded(response.data.data))
                .catch(error => {
                });
        }

        function updatePaymentRow(payment_id, type) {

            let item = null;

            switch (type) {
                case CONSULENZE:
                    item = $(TABLE_CONSULENZE_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break;
                case VENDITE:
                    item = $(TABLE_VENDITE_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break;
                case CANALI_DI_VENDITA:
                    item = $(TABLE_CANALI_DI_VENDITA_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break;
                case FATTURE_CATALOGO:
                    item = $(TABLE_FATTURE_CATALOGO_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break;
                case FATTURE_FUORI_CATALOGO:
                    item = $(TABLE_FATTURE_FUORI_CATALOGO_BODY).find(`tr[data-payment-id=${payment_id}]`);
                    break;
            }

            if (item && item.length) {
                item.addClass('table-success');
                item.find('.td-paid-check').append(`<i class="font-size-18 bx bx-check"></i>`);
                item.find(BTN_MARK_AS_PAID).addClass('d-none');
            }
        }

        function paymentMarkedAsPaid(payment, callback) {

            loadAccounting();

            if (callback && typeof callback === "function") {
                callback();
            }
        }

        function markPaymentAsPaid(payment_id, callback) {

            httpRequest.put(`admin/content/api/payments/${payment_id}/mark-as-paid`)
                .then(response => paymentMarkedAsPaid(response.data.data, callback))
                .catch(error => {

                });
        }

        $(TABLE_CONSULENZE_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, CONSULENZE);
            });
        });

        $(TABLE_VENDITE_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, VENDITE);
            });
        });

        $(TABLE_CANALI_DI_VENDITA_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, CANALI_DI_VENDITA);
            });
        });

        $(TABLE_FATTURE_CATALOGO_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, FATTURE_CATALOGO);
            });
        });

        $(TABLE_FATTURE_FUORI_CATALOGO_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            markPaymentAsPaid(payment_id, function () {
                updatePaymentRow(payment_id, FATTURE_FUORI_CATALOGO);
            });
        });

        loadAccounting();
    },

    finalize() {

    },
}
